import React from 'react';
import PropTypes from 'prop-types';

import { DropdownMenu } from './DropdownMenu';

class DropdownMenuContainer extends React.Component {
  state = { isMenuVisible: false };

  toggleMenuVisibility = () => {
    const { isMenuVisible } = this.state;
    this.setState({ isMenuVisible: !isMenuVisible });
  };

  render() {
    const { isMenuVisible } = this.state;
    const {
      renderPressableContent,
      renderMenuHeader,
      renderMenuFooter,
      menuItems,
    } = this.props;
    return (
      <DropdownMenu
        toggleMenuVisibility={this.toggleMenuVisibility}
        isMenuVisible={isMenuVisible}
        renderPressableContent={renderPressableContent}
        menuItems={menuItems}
        renderMenuHeader={renderMenuHeader}
        renderMenuFooter={renderMenuFooter}
      />
    );
  }
}

DropdownMenuContainer.defaultProps = {
  renderMenuHeader: null,
  renderMenuFooter: null,
};

DropdownMenuContainer.propTypes = {
  renderPressableContent: PropTypes.element.isRequired,
  renderMenuHeader: PropTypes.element,
  renderMenuFooter: PropTypes.element,
  menuItems: PropTypes.element.isRequired,
};

export { DropdownMenuContainer };
